import { useEffect, useState } from 'react';
import { PageTransition } from '../components/layout';
import { toast } from 'sonner';
import { Download, ShoppingBag } from 'lucide-react';
import axios from 'axios';
import { useCart } from '../context/CartContext';
import { toAbsoluteUrl } from '../lib/utils';
import formationBandBienEtre from '../assets/images/img_formation_band_1.jpg';
import formationBandOnglerie from '../assets/images/img_formation_band_2.jpg';
import formationBandManucure from '../assets/images/img_formation_band_3.jpg';
import formationDebutantImage from '../assets/images/img_formation_debutant.jpg';
import formationMaderoImage from '../assets/images/img_formation_madero.jpg';
import formationPerfImage from '../assets/images/img_formation_perf.jpg';
import './FormationPage.css';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Contenu repris de la maquette HTML statique de la page formation.
const heroSlides = [
  {
    src: formationBandBienEtre,
    alt: 'Bien-être'
  },
  {
    src: formationBandOnglerie,
    alt: 'Onglerie'
  },
  {
    src: formationBandManucure,
    alt: 'Manucure'
  }
];

const formations = [
  {
    id: 'formation-debutante',
    number: '01',
    tabTitle: 'Formation Débutante',
    price: '500€',
    eyebrow: '01 · Onglerie · Débutante',
    title: 'Formation Débutante',
    tagline: 'Le parcours complet pour lancer votre carrière en onglerie',
    image: formationDebutantImage,
    desiredTraining: 'Formation Débutante (2 jours - 500€)',
    items: [
      "Protocole d'hygiène complet",
      "Anatomie & maladies de l'ongle",
      'Manucure combinée & russe',
      'Préparation plaque & outils',
      'Module gels & textures',
      'Formes classiques en institut',
      'Patch acrygel - renfort & gainage',
      'Gel X & fondu aux cuticules',
      'Nail art rapide, moderne & rentable · Entraînement sur modèle supervisé'
    ],
    option: {
      title: 'Option · +1 jour · +180€',
      tags: ['Extension Popit', 'VSP sous cuticules', 'Baby-boomer & French', 'Astuces photos', 'Dépose complète']
    },
    included: ['Livret de formation', 'Certificat', 'Suivi post-formation', 'Conseils fournisseurs', 'Kit débutant +130€', 'Auto Financement'],
    duration: '2 jours',
    note: '9h30 - 17h30'
  },
  {
    id: 'perfectionnement',
    number: '02',
    tabTitle: 'Perfectionnement',
    price: '300€',
    eyebrow: '02 · Onglerie · Confirmée',
    title: 'Perfectionnement',
    tagline: 'Programme entièrement personnalisable selon vos besoins',
    image: formationPerfImage,
    imagePosition: 'center top',
    desiredTraining: 'Perfectionnement Solo (1 jour - 300€)',
    items: [
      'Théorie & hygiène',
      'Manucure russe & combinée',
      'Patch acrygel',
      'Gainage - renfort',
      'Popit ou chablon',
      'Sans limage',
      'Gel X',
      'VSP sous cuticules',
      'Dépose complète',
      'Astuces photo',
      'Nail art : Baby-boomer, babycolors, cat eyes, 3D, Chromes, French...',
      'Correction des problèmes rencontrés sur vos clientes'
    ],
    included: ['Matériel fourni sur place', 'Livret de formation', 'Certificat', 'Liste fournisseurs', 'Kit offert', 'Auto Financement'],
    duration: '1 jour · Solo',
    note: 'Duo : 220€ / pers.'
  },
  {
    id: 'maderotherapie',
    number: '03',
    tabTitle: 'Madérothérapie',
    price: '300€',
    eyebrow: '03 · Bien-être · Massage sculptant',
    title: 'Madérothérapie & Drainage Lymphatique',
    tagline: 'Maîtrisez les techniques de massage sculptant et de drainage',
    image: formationMaderoImage,
    desiredTraining: 'Madérothérapie 1 technique (1 jour - 300€)',
    items: [
      'Système lymphatique, bienfaits & adaptation du soin à la cliente',
      "Contre-indications, règles d'hygiène & sécurité",
      'Gestes techniques (pressions, rythmes, enchaînements)',
      'Protocole complet de séance & erreurs à éviter',
      'Outils en bois & massage sculptant',
      'Protocoles par zone (ventre, jambes, bras...)',
      'Mise en situation réelle sur modèle',
      'Créer des cures attractives & rentables',
      'Fixer vos tarifs & fidéliser',
      'Conseils personnalisés au lancement'
    ],
    included: ['Support de formation', 'Conseils lancement', 'Certification', 'Auto Financement'],
    duration: '1 technique · 1 jour',
    note: '2 techniques : 500€ / 2j'
  }
];

const formationOptions = [
  'Formation Débutante',
  'Perfectionnement',
  'Madérothérapie / Drainage Lymphatique'
];

const productOffers = [
  {
    id: 'livret-debutant',
    title: 'Livret de formation Débutant',
    shortTitle: 'Livret Débutant',
    priceKey: 'beginner_book_price',
    description: [
      "Pour les plus autodidacte d'entre vous, celle qui souhaite apprendre à leur rythme.",
      "J'ai choisis de proposé mon livret de formation. Vous y trouverez, les fondamentaux de notre métiers, les procédure essentiel au bon fonctionnement de votre institut.",
      'Un contenu condensé en 26 pages pour vous transmettre les bases de cette formation.'
    ]
  },
  {
    id: 'kit-demarrage',
    title: 'Kit de démarrage',
    shortTitle: 'Kit de démarrage',
    priceKey: 'starter_kit_price',
    description: [
      "La maîtrise des connaissances est primordiale. Mais associée aux bons outils, elle fait toute la différence.",
      "J’ai soigneusement sélectionné un ensemble de produits professionnels pour vous offrir un kit complet, pensé pour sublimer votre travail et révéler votre plein potentiel.",
      "Ce kit comprend :"
    ],
    items: [
      'Nail prep',
      'Une base',
      'Top coat',
      '2 Couleurs',
      '1 Primer',
      'Ciseaux',
      'Embout cuticule',
      'Bloc ponse',
      'Capsule entrainement Gel X',
      'Une Lime',
      'Baton de bui, Ruber base',
      'Demi capsule',
      'Pot de gel construction',
      'Embouts Emeris',
      'Paillote de dépose',
      'Liquide fonte',
      'Cleaner'
    ]
  }
];

const faqItems = [
  {
    title: "À qui s'adressent les formations ?",
    text: "Aux professionnelles et futures professionnelles de l'esthétique souhaitant acquérir ou perfectionner des techniques haut de gamme."
  },
  {
    title: 'Le matériel est-il fourni ?',
    text: 'Un livret complet est fourni. Certains parcours recommandent un kit professionnel en complément pour une mise en pratique optimale.'
  },
  {
    title: 'Y a-t-il un certificat ?',
    text: "Oui, un certificat de formation est remis à l'issue de chaque parcours pour valoriser votre expertise auprès de vos clientes."
  },
  {
    title: 'Comment réserver ?',
    text: 'Remplissez le formulaire ci-dessous en précisant la formation choisie. Nous revenons vers vous sous 24h pour confirmer votre date.'
  }
];

export default function FormationPage() {
  const { addItem } = useCart();
  // États d'interface pour le hero, les accordéons, la FAQ et le formulaire.
  const [heroIndex, setHeroIndex] = useState(0);
  const [activePanel, setActivePanel] = useState(formations[0].id);
  const [activeFaqs, setActiveFaqs] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    desiredTraining: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [productConfig, setProductConfig] = useState({
    beginner_book_price: 49.90,
    starter_kit_price: 149.90,
    summary_pdf_url: null
  });

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setHeroIndex((current) => (current + 1) % heroSlides.length);
    }, 5000);

    return () => window.clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const fetchProductConfig = async () => {
      try {
        const response = await axios.get(`${API_URL}/formations/products/config`);
        setProductConfig((current) => ({ ...current, ...response.data }));
      } catch (err) {
        console.error('Formation product config error:', err);
      }
    };

    fetchProductConfig();
  }, []);

  const slideHero = (direction) => {
    setHeroIndex((current) => (current + direction + heroSlides.length) % heroSlides.length);
  };

  const toggleFaq = (index) => {
    setActiveFaqs((current) => (
      current.includes(index)
        ? current.filter((item) => item !== index)
        : [...current, index]
    ));
  };

  const handleReserveFormation = (training) => {
    setFormData((current) => ({ ...current, desiredTraining: training }));
    document.getElementById('formation-contact-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  const formatPrice = (price) => `${Number(price || 0).toFixed(2).replace('.', ',')}€`;

  const getOfferPrice = (offer) => Number(productConfig[offer.priceKey] || 0);

  const handleProductPurchase = (offer) => {
    const price = getOfferPrice(offer);
    addItem({
      type: 'formation_product',
      product_id: offer.id,
      product_name: offer.title,
      quantity: 1,
      totalPrice: price
    });
    toast.success(`${offer.title} ajouté au panier.`);
  };

  const handleDownloadSummary = () => {
    if (!productConfig.summary_pdf_url) {
      toast.error('Le sommaire PDF n’est pas encore configuré.');
      return;
    }

    const link = document.createElement('a');
    link.href = toAbsoluteUrl(productConfig.summary_pdf_url);
    link.download = 'sommaire-livret-formation-debutant.pdf';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.click();
  };

  // Réutilise l'endpoint existant afin de synchroniser dashboard admin et email de notification.
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.phone || !formData.desiredTraining) {
      toast.error('Merci de remplir votre nom, email, téléphone et la formation souhaitée.');
      return;
    }
    if (!formData.email.includes('@')) {
      toast.error('Veuillez entrer une adresse email valide');
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await axios.post(`${API_URL}/formations/interest`, {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        desired_training: formData.desiredTraining,
        message: formData.message
      });
      if (response.status === 200 || response.status === 201) {
        setIsSubmitted(true);
        toast.success('Merci ! Votre demande a bien été envoyée.');
      } else {
        toast.error('Erreur lors de l\'envoi. Veuillez réessayer.');
      }
    } catch (err) {
      console.error('Formation interest error:', err);
      toast.error('Erreur lors de l\'envoi. Veuillez réessayer.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PageTransition>
      <main className="formation-page">
        <section className="formation-hero">
          <div
            className="formation-hero-slider"
            style={{ transform: `translateX(-${heroIndex * 100}%)` }}
          >
            {heroSlides.map((slide) => (
              <div className="formation-hero-slide" key={slide.src}>
                <img src={slide.src} alt={slide.alt} />
              </div>
            ))}
          </div>
          <div className="formation-hero-content">
            <p className="formation-hero-eyebrow">Institut Madame DSRS - Onglerie & Bien-être</p>
            <h1 className="formation-hero-title">Formations</h1>
            <p className="formation-hero-sub">
              Perfectionnez votre expertise esthétique avec nos formations professionnelles premium.
            </p>
          </div>
          <div className="formation-hero-controls">
            <button type="button" className="formation-hero-btn" onClick={() => slideHero(-1)} aria-label="Formation précédente">‹</button>
            <button type="button" className="formation-hero-btn" onClick={() => slideHero(1)} aria-label="Formation suivante">›</button>
          </div>
          <div className="formation-hero-dots">
            {heroSlides.map((slide, index) => (
              <button
                type="button"
                key={slide.src}
                className={`formation-hero-dot ${heroIndex === index ? 'active' : ''}`}
                onClick={() => setHeroIndex(index)}
                aria-label={`Afficher le visuel ${index + 1}`}
              />
            ))}
          </div>
        </section>

        <section className="formation-stats-bar" aria-label="Informations clés sur les formations">
          <div className="formation-stat-item"><div className="formation-stat-num">4</div><div className="formation-stat-label">Formations différentes disponibles</div></div>
          <div className="formation-stat-item"><div className="formation-stat-num">Sur Mesure</div><div className="formation-stat-label">En Duo ou En Solo</div></div>
          <div className="formation-stat-item"><div className="formation-stat-num">100%</div><div className="formation-stat-label">Certifiées</div></div>
        </section>

        <section className="formation-intro-block">
          <h2 className="formation-sec-title">Formez-vous avec élégance, méthode et impact.</h2>
          <p className="formation-intro-text">
            J’ai créé ces formations avec une seule idée en tête : transmettre ce que j’aurais aimé apprendre plus tôt.
            Derrière chaque module, il y a du temps, de l’implication et une vraie volonté de vous accompagner à chaque étape.
            Peu importe votre niveau, vous avez votre place ici.
          </p>
          <p>
            Mes formations sont pensées pour s’adapter aux besoins de chacune, que vous soyez débutante ou déjà expérimentée.
            Sur une journée complète de 9h30 à 17h30, je vous accompagne avec des méthodes concrètes pour améliorer la qualité
            de vos prestations, structurer vos protocoles et développer votre image, notamment sur les réseaux sociaux. Chaque
            programme est modulable pour vous permettre de progresser efficacement selon votre niveau.
          </p>
          <p className="formation-intro-cta">Et si c’était le bon moment pour vous lancer ?</p>
        </section>

        <section className="formation-accordion-section" id="acc">
          <div className="formation-accordion-header">
            <p className="formation-eyebrow">Nos formations</p>
            <h2 className="formation-sec-title">Choisissez votre parcours</h2>
            <p className="formation-sec-sub">Cliquez sur une formation pour découvrir le programme complet</p>
          </div>

          <div className="formation-accordion-wrapper">
            <div className="formation-accordion">
              {formations.map((formation) => {
                const isActive = activePanel === formation.id;

                return (
                  <article
                    key={formation.id}
                    className={`formation-panel ${isActive ? 'active' : ''}`}
                    onClick={() => setActivePanel(formation.id)}
                  >
                    <div
                      className="formation-panel-bg"
                      style={{
                        backgroundImage: `url('${formation.image}')`,
                        backgroundPosition: formation.imagePosition || 'center'
                      }}
                    />
                    <div className="formation-panel-overlay" />
                    <div className="formation-panel-tab">
                      <span className="formation-tab-num">{formation.number}</span>
                      <span className="formation-tab-title">{formation.tabTitle}</span>
                      <span className="formation-tab-price">{formation.price}</span>
                    </div>
                    <div className="formation-panel-content">
                      <div>
                        <div className="formation-pc-eyebrow">{formation.eyebrow}</div>
                        <div className="formation-pc-title">{formation.title}</div>
                        <div className="formation-pc-tagline">{formation.tagline}</div>
                        <div className="formation-pc-cols">
                          {formation.items.map((item, index) => (
                            <div
                              className={`formation-pc-item ${item.length > 80 || index > 9 ? 'full' : ''}`}
                              key={item}
                            >
                              <span className="formation-pc-dot" />
                              <span>{item}</span>
                            </div>
                          ))}
                        </div>

                        {formation.option && (
                          <div className="formation-option-box">
                            <div className="formation-option-title">{formation.option.title}</div>
                            <div className="formation-option-tags">
                              {formation.option.tags.map((tag) => (
                                <span className="formation-option-tag" key={tag}>{tag}</span>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="formation-pc-bottom">
                        <div>
                          <div className="formation-pc-included">
                            {formation.included.map((item) => (
                              <span className="formation-pc-tag" key={item}>{item}</span>
                            ))}
                          </div>
                          <button
                            type="button"
                            className="formation-pc-btn"
                            onClick={(event) => {
                              event.stopPropagation();
                              handleReserveFormation(formation.desiredTraining);
                            }}
                          >
                            Réserver cette formation ↓
                          </button>
                        </div>
                        <div className="formation-pc-price-col">
                          <div className="formation-pc-price">{formation.price}</div>
                          <div className="formation-pc-duration">{formation.duration}</div>
                          <div className="formation-pc-option">{formation.note}</div>
                        </div>
                      </div>
                    </div>
                    <div className="formation-panel-hint">→</div>
                  </article>
                );
              })}
            </div>
            <div className="formation-panel-nav">
              {formations.map((formation) => (
                <button
                  type="button"
                  key={formation.id}
                  className={`formation-panel-nav-dot ${activePanel === formation.id ? 'active' : ''}`}
                  onClick={() => setActivePanel(formation.id)}
                  aria-label={`Afficher ${formation.tabTitle}`}
                />
              ))}
            </div>
          </div>
        </section>

        <section className="formation-products-section" aria-labelledby="formation-products-title">
          <div className="formation-products-inner">
            <p className="formation-eyebrow">À votre rythme</p>
            <h2 id="formation-products-title" className="formation-sec-title">Chacune son rythme</h2>

            <div className="formation-product-card formation-product-card--book">
              <div className="formation-product-copy">
                <h3 className="formation-product-title">{productOffers[0].title}</h3>
                {productOffers[0].description.map((text) => (
                  <p className="formation-product-text" key={text}>{text}</p>
                ))}
              </div>
              <div className="formation-product-aside">
                <div className="formation-product-visual formation-product-visual--book" aria-hidden="true">
                  <div className="formation-book-cover">
                    <span className="formation-book-brand">DSRS</span>
                    <span className="formation-book-title">Livret Débutant</span>
                  </div>
                </div>
                <button
                  type="button"
                  className="formation-product-buy"
                  onClick={() => handleProductPurchase(productOffers[0])}
                >
                  <ShoppingBag size={18} />
                  <span>{productOffers[0].shortTitle} {formatPrice(getOfferPrice(productOffers[0]))}</span>
                </button>
                <button
                  type="button"
                  className="formation-product-download"
                  onClick={handleDownloadSummary}
                >
                  <Download size={24} strokeWidth={2} />
                  <span>Télécharger le sommaire</span>
                </button>
              </div>
            </div>

            <div className="formation-product-card formation-product-card--kit">
              <div className="formation-product-aside formation-product-aside--kit">
                <div className="formation-product-visual formation-product-visual--kit" aria-hidden="true">
                  <span className="formation-kit-bottle formation-kit-bottle--large" />
                  <span className="formation-kit-bottle formation-kit-bottle--medium" />
                  <span className="formation-kit-tube" />
                  <span className="formation-kit-brush" />
                  <span className="formation-kit-pot" />
                </div>
                <button
                  type="button"
                  className="formation-product-buy"
                  onClick={() => handleProductPurchase(productOffers[1])}
                >
                  <ShoppingBag size={18} />
                  <span>{productOffers[1].shortTitle} {formatPrice(getOfferPrice(productOffers[1]))}</span>
                </button>
              </div>
              <div className="formation-product-copy">
                <h3 className="formation-product-title">{productOffers[1].title}</h3>
                {productOffers[1].description.map((text) => (
                  <p className="formation-product-text" key={text}>{text}</p>
                ))}
                <ul className="formation-kit-list">
                  {productOffers[1].items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
                <p className="formation-product-signature">A vos pinceaux !</p>
              </div>
            </div>
          </div>
        </section>

        <section className="formation-why-section">
          <div className="formation-accordion-header">
            <p className="formation-eyebrow">Questions Fréquentes</p>
          </div>
          <div className="formation-why-grid">
            {faqItems.map((item, index) => {
              const isActive = activeFaqs.includes(index);

              return (
                <div
                  key={item.title}
                  className={`formation-why-card ${isActive ? 'active' : ''}`}
                  onClick={() => toggleFaq(index)}
                >
                  <div className="formation-why-sym">Q</div>
                  <div className="formation-why-title">{item.title}</div>
                  <ul className="formation-why-list">
                    <li>{item.text}</li>
                  </ul>
                </div>
              );
            })}
          </div>
        </section>

        <section id="formation-contact-section" className="formation-contact-section">
          <h3 className="formation-contact-title">Réserver votre formation</h3>
          <p className="formation-contact-sub">
            Une question, une disponibilité à vérifier ? Contactez-nous et nous vous répondrons dans les plus brefs délais.
          </p>

          {isSubmitted ? (
            <div className="formation-success-msg">
              Merci ! Votre demande a bien été envoyée. Nous vous recontacterons très prochainement.
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="formation-form-grid">
                <div className="formation-fg">
                  <label className="formation-flabel" htmlFor="formation-name">Prénom & Nom</label>
                  <input
                    id="formation-name"
                    type="text"
                    className="formation-finput"
                    value={formData.name}
                    onChange={(event) => setFormData((current) => ({ ...current, name: event.target.value }))}
                    placeholder="Marie Dupont"
                  />
                </div>
                <div className="formation-fg">
                  <label className="formation-flabel" htmlFor="formation-email">Email</label>
                  <input
                    id="formation-email"
                    type="email"
                    className="formation-finput"
                    value={formData.email}
                    onChange={(event) => setFormData((current) => ({ ...current, email: event.target.value }))}
                    placeholder="marie@email.com"
                  />
                </div>
                <div className="formation-fg">
                  <label className="formation-flabel" htmlFor="formation-phone">Téléphone</label>
                  <input
                    id="formation-phone"
                    type="tel"
                    className="formation-finput"
                    value={formData.phone}
                    onChange={(event) => setFormData((current) => ({ ...current, phone: event.target.value }))}
                    placeholder="06 00 00 00 00"
                  />
                </div>
                <div className="formation-fg">
                  <label className="formation-flabel" htmlFor="formation-training">Formation souhaitée</label>
                  <select
                    id="formation-training"
                    className="formation-finput"
                    value={formData.desiredTraining}
                    onChange={(event) => setFormData((current) => ({ ...current, desiredTraining: event.target.value }))}
                  >
                    <option value="">Choisir une formation...</option>
                    {formationOptions.map((option) => (
                      <option value={option} key={option}>{option}</option>
                    ))}
                  </select>
                </div>
                <div className="formation-fg full">
                  <label className="formation-flabel" htmlFor="formation-message">Message (facultatif)</label>
                  <textarea
                    id="formation-message"
                    className="formation-finput"
                    rows="3"
                    value={formData.message}
                    onChange={(event) => setFormData((current) => ({ ...current, message: event.target.value }))}
                    placeholder="Vos disponibilités, vos questions..."
                    maxLength={2000}
                    style={{ resize: 'vertical' }}
                  />
                </div>
              </div>
              <button type="submit" className="formation-form-submit" disabled={isSubmitting}>
                {isSubmitting ? 'Envoi en cours...' : 'Envoyer ma demande'}
              </button>
            </form>
          )}
        </section>
      </main>

    </PageTransition>
  );
}
